import { MessengerKnowledgeBaseMode } from './messengerSettings.types';

export const knowledgeBaseMode = {
  displayRelatedArticles: 'display-related-articles-on-the-home-page',
  displayLinkToArticles: 'display-button-for-access-to-articles',
} as const satisfies Record<string, MessengerKnowledgeBaseMode>
